
// import { useState } from "react";
import React, { useState, useEffect } from "react";

const videos = [
  {
    id: "cQrEYMFUX18",
    title: "MG Astor Complete Review | Most Underrated Car of the Segment | Spare Wheel",
  },
  {
    id: "rKOpMsvSOKo",
    title: "@13.43 LAKH में PERFECT FEATURE LOADED SUV 👌🏻 - 2025 MG ASTOR SELECT HONEST IMPRESSIONS✅",
  },
  {
    id: "whf0my9o9as",
    title: "Creta/Seltos Killer ? 2025 Mg Astor Shine",
  },
];

const styles = {
  section: {
    fontFamily: "'Georgia', serif",
    background: "#fff",
    padding: "60px 0 80px",
    overflow: "hidden",
    position: "relative",
  },
  heading: {
    textAlign: "center",
    color: "#c0001d",
    fontSize: "2.1rem",
    fontWeight: "700",
    letterSpacing: "0.01em",
    marginBottom: "48px",
    fontFamily: "'Georgia', serif",
  },
  carouselWrapper: {
    position: "relative",
    maxWidth: "1320px",
    margin: "0 auto",
    padding: "0 20px",
  },
  track: {
    display: "flex",
    gap: "20px",
    transition: "transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    willChange: "transform",
  },
  card: {
    minWidth: "calc(50% - 10px)",
    background: "#fff",
    borderRadius: "4px",
    overflow: "hidden",
    flexShrink: 0,
  },
  iframeWrapper: {
    position: "relative",
    paddingBottom: "56.25%",
    height: 0,
    overflow: "hidden",
    background: "#000",
  },
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: "none",
  },
  cardTitle: {
    padding: "14px 4px 6px",
    fontSize: "0.95rem",
    color: "#222",
    fontWeight: "600",
    fontFamily: "'Arial', sans-serif",
    lineHeight: 1.4,
    height: "54px",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  navRow: {
    display: "flex",
    justifyContent: "center",
    gap: "12px",
    marginTop: "40px",
  },
  navBtn: {
    width: "46px",
    height: "46px",
    borderRadius: "20%",
    background: "#c0001d",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.2s, transform 0.15s",
    color: "#fff",
    fontSize: "1.25rem",
    lineHeight: 1,
    fontWeight: "bold",
  },
  navBtnDisabled: {
    background: "#e0001d",
    opacity: 0.45,
    cursor: "not-allowed",
  },
  overflow: {
    overflow: "hidden",
  },
};

export default function VideoCarousel({ videos = [], heading = "Auto Expert Reviews" }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(2);

  // Responsive logic
  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(window.innerWidth < 640 ? 1 : 2);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const maxIndex = Math.max(0, videos.length - visibleCount);

  const prev = () => setCurrentIndex((i) => Math.max(0, i - 1));
  const next = () => setCurrentIndex((i) => Math.min(maxIndex, i + 1));

  return (
    <>
      <style>{`
        .reviews-section {
          font-family: 'Georgia', serif;
          background: #fff;
          padding: 60px 0 80px;
          overflow: hidden;
        }

        .reviews-heading {
          text-align: center;
          color: #c0001d;
          font-size: 2.1rem;
          font-weight: 700;
          margin-bottom: 48px;
        }

        .carousel-wrapper {
          max-width: 1320px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .carousel-overflow {
          overflow: hidden;
        }

        .carousel-track {
          display: flex;
          gap: 20px;
          transition: transform 0.5s ease;
        }

        .video-card {
          flex: 0 0 calc(50% - 10px);
          background: #fff;
          border-radius: 6px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          transition: 0.3s;
          box-shadow: 0 2px 12px rgba(0,0,0,0.07);
        }

        .video-card:hover {
          box-shadow: 0 8px 32px rgba(192,0,29,0.12);
          transform: translateY(-3px);
        }

        .iframe-wrapper {
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          background: #000;
        }

        .iframe-wrapper iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: none;
        }

        .card-title {
          padding: 14px;
          font-size: 0.95rem;
          font-weight: 600;
          font-family: Arial, sans-serif;
          line-height: 1.4;
        }

        .nav-row {
          display: flex;
          justify-content: center;
          gap: 12px;
          margin-top: 40px;
        }

        .nav-btn {
          width: 46px;
          height: 46px;
          border-radius: 20%;
          background: #c0001d;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 1.4rem;
          font-weight: bold;
          transition: 0.2s;
        }

        .nav-btn:hover:not(:disabled) {
          background: #a0001a;
          transform: scale(1.08);
        }

        .nav-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }

        /* Mobile */
        @media (max-width: 639px) {
          .video-card {
            flex: 0 0 100%;
          }

          .reviews-heading {
            font-size: 1.4rem;
            margin-bottom: 24px;
          }

          .reviews-section {
            padding: 40px 0 60px;
          }
        }
      `}</style>

      <div className="reviews-section">
        <h2 className="reviews-heading">{heading}</h2>

        <div className="carousel-wrapper">
          <div className="carousel-overflow">
            <div
              className="carousel-track"
              style={{
                transform: `translateX(calc(-${currentIndex} * (${visibleCount === 1 ? "100%" : "50%"} + 10px)))`,
              }}
            >
              {videos.map((v, i) => (
                <div key={i} className="video-card">
                  <div className="iframe-wrapper">
                    <iframe
                      src={`https://www.youtube.com/embed/${v.id}`}
                      title={v.title}
                      allowFullScreen
                    />
                  </div>
                  <div className="card-title">{v.title}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="nav-row">
            <button
              className="nav-btn"
              onClick={prev}
              disabled={currentIndex === 0}
            >
              ‹
            </button>
            <button
              className="nav-btn"
              onClick={next}
              disabled={currentIndex >= maxIndex}
            >
              ›
            </button>
          </div>
        </div>
      </div>
    </>
  );
}